"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DarkPalette = exports.LightPalette = void 0;
// All Mapped colors
var MappedColors = {
    white: '#ffffff',
    black: '#000000',
    eletricBlue: {
        main: '#4A3BCF',
        a70: '#8076DD',
        a50: '#A49DE7',
        a20: '#DBD8F5',
        a10: '#F6F5Fd',
    },
    blue: {
        main: '#4D5F80',
        a80: '#717F99',
        a60: '#A0AEC0',
        a40: '#B8BFCC',
        a10: '#EDEFF2',
    },
    slate: {
        main: '#191F2C',
        a70: '#5E626B',
        a50: '#8C8F95',
        a20: '#D1D2D5',
        a10: '#E8E9EA',
        a05: '#f6f6f6',
        a03: '#F9F9F9',
    },
    teal: {
        main: '#51C0AC',
    },
    alert: {
        main: '#F56565',
    },
    notice: {
        main: '#F2C94C',
    },
};
exports.LightPalette = {
    mode: 'light',
    divider: MappedColors.slate.a10,
    background: {
        default: MappedColors.white,
        paper: MappedColors.slate.a03,
    },
    text: __assign(__assign({}, MappedColors.slate), { primary: MappedColors.slate.main, secondary: MappedColors.slate.a70, disabled: MappedColors.slate.a50 }),
    primary: __assign(__assign({}, MappedColors.eletricBlue), { light: MappedColors.eletricBlue.a70 }),
    secondary: __assign(__assign({}, MappedColors.teal), { contrastText: '#fff' }),
    action: {
        hover: MappedColors.slate.a05,
    },
    success: __assign(__assign({}, MappedColors.teal), { contrastText: '#fff' }),
    error: MappedColors.alert,
    warning: MappedColors.notice,
    info: MappedColors.blue,
};
exports.DarkPalette = exports.LightPalette;
